import { FieldsEnum, FormsEnum } from 'app/shared/enums';
import {
  getQuotationIsFromRenewal,
  setDataOwnersChangedRenewal,
  setQuestionVisibility,
  changeQuestionClearOnHide,
} from 'app/services/businessFunctionHelpers';

export function handleOnChangeDataFirstCoOwnerRenewal(initialRun?: boolean) {
  const isFromRenewal = getQuotationIsFromRenewal();

  if (isFromRenewal && !initialRun) {
    setDataOwnersChangedRenewal({
      ownerName: 'firstCoOwner',
      isChanged: true,
    });

    changeQuestionClearOnHide(
      FieldsEnum.Coowners1LicenseYear,
      FormsEnum.CalculationForm,
      true
    );
    changeQuestionClearOnHide(
      FieldsEnum.Coowners1LicenseMonth,
      FormsEnum.CalculationForm,
      true
    );
    changeQuestionClearOnHide(
      FieldsEnum.Coowners1NoDrivingLicense,
      FormsEnum.CalculationForm,
      true
    );
    setQuestionVisibility({
      key: FieldsEnum.Coowners1LicenseYear,
      visible: true,
      formName: FormsEnum.CalculationForm,
    });
    setQuestionVisibility({
      key: FieldsEnum.Coowners1NoDrivingLicense,
      visible: true,
      formName: FormsEnum.CalculationForm,
    });
  }
}
